import { render, staticRenderFns } from "./NuiteqSetting.vue?vue&type=template&id=19f41829&"
import script from "./NuiteqSetting.vue?vue&type=script&lang=js&"
export * from "./NuiteqSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports